import { NavigationOptions } from './typing';

/**
 * 微信JSSDK
 */
export namespace WeappSDK {

  export function redirectTo(url: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      window.wx.miniProgram.redirectTo({
        url: url,
        success: () => {
          resolve();
        },
        fail: () => {
          reject();
        },
      });
    });
  }
  export function navigateTo(url: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      window.wx.miniProgram.navigateTo({
        url: url,
        success: () => {
          resolve();
        },
        fail: () => {
          reject();
        },
      });
    });
  }
  export function postMessage(message: any): Promise<void> {
    return new Promise<void>(() => {
      window.wx.miniProgram.postMessage({
        data: message,
      });
    });
  }
  export function navigateBack() {
    return new Promise<void>((resolve, reject) => {
      window.wx.miniProgram.navigateBack({
        success: () => {
          resolve();
        },
        fail: () => {
          reject();
        },
      });
    });
  }
  export function reLaunch(url: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      window.wx.miniProgram.reLaunch({
        url: url,
        success: () => {
          resolve();
        },
        fail: () => {
          reject();
        },
      });
    });
  }
}

export function navigateToWeapp(
  target: string,
  { replace }: NavigationOptions = {},
) {
  if (replace) {
    return WeappSDK.redirectTo(target);
  } else {
    return WeappSDK.navigateTo(target);
  }
}
